import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'
import notificationsService from '@/lib/services/notificationsService'

export function useNotifications() {
  const notificationsQuery = useQuery({
    queryFn: () => notificationsService.getNotifications(),
    queryKey: QUERY_KEYS.notifications,
    refetchOnWindowFocus: false,
  })

  return notificationsQuery.data?.['hydra:member'] || []
}
